import React from 'react';

// Types
import type { WBudgetItemView } from '@zola/svc-web-api-ts-client';

// Components
import BudgetPaymentReminder from 'components/manage/budget/BudgetPaymentReminder';

// Utils
import convertCurrencyFormat from '@zola-helpers/client/dist/es/util/convertCurrencyFormat';

// Styles
import {
  PaidRemaining,
  PaidRemainingCurrency,
  PaymentsHeader,
  StyledP,
  AddPaymentButton,
} from '../BudgetItemView.styles';

type BudgetItemViewPaymentsProps = {
  paidCents: WBudgetItemView['paid_cents'];
  dueCents: WBudgetItemView['balance_due_cents'];
  payments: WBudgetItemView['payments'];
  itemUuid: string;
  handleStashChangesAndChangeRoute: (path: string) => void;
};

const BudgetItemViewPayments = ({
  paidCents = 0,
  dueCents = 0,
  payments,
  itemUuid,
  handleStashChangesAndChangeRoute,
}: BudgetItemViewPaymentsProps) => (
  <>
    <PaidRemaining>
      <span>Paid:</span>
      <PaidRemainingCurrency>
        {convertCurrencyFormat(paidCents / 100, 'USD', 2)}
      </PaidRemainingCurrency>
      <span>Remaining due:</span>
      <PaidRemainingCurrency>
        {convertCurrencyFormat(dueCents / 100, 'USD', 2)}
      </PaidRemainingCurrency>
    </PaidRemaining>
    <PaymentsHeader>Payments and reminders</PaymentsHeader>
    {payments?.length ? (
      payments.map(payment => (
        <BudgetPaymentReminder key={payment.uuid} payment={payment} extended />
      ))
    ) : (
      <StyledP>Track your payments and get alerts on deadlines.</StyledP>
    )}
    <AddPaymentButton
      variant="secondary"
      onClick={() => handleStashChangesAndChangeRoute(`/item/${itemUuid}/payment/new`)}
    >
      Add a payment or reminder
    </AddPaymentButton>
  </>
);

export default BudgetItemViewPayments;
